import React from 'react'
import {
  Select,
  MenuItem,
  Typography,
  Box,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.body1,
  },
  label: {
    paddingBottom: theme.spacing(0.5),
  },
  select: {
    width: '100%',
    height: 46,
  },
  item: {
    width: '100%',
  },
  outlined: {
    borderRadius: '2px',
    padding: '6px 14px 6px 12px',
  },
}))

const SelectBox = ({ ...props }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <label htmlFor={'select' + props.label}>
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.label}
        >
          {props.label}
        </Typography>
      </label>
      <Select
        id={'select' + props.label}
        // labelId="selectLabel"
        classes={{
          root: classes.root,
          outlined: classes.outlined,
          // iconOutlined: classes.iconOutlined,
        }}
        variant="outlined"
        className={classes.select}
        value={props.current}
        onChange={props.handleChange}
        IconComponent={ExpandMoreIcon}
      >
        {props.options.map((el, i) => {
          return (
            <MenuItem
              className={classes.item}
              value={el.val}
              key={`item-${i}`}
            >
              {el.display}
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}

SelectBox.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  current: PropTypes.string,
  handleChange: PropTypes.func,
  // showHelp: PropTypes.string,
}

export default SelectBox
